export default __webpack_public_path__ + "static/media/logo_blue_white.0296052c.png";